module.exports = __webpack_public_path__ + "static/img/3_4.43135dfa.jpg";